var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWalletinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "4781810_coin_currency_dollar_finance_money_icon"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 47",
    d: "M13.068 16.128H4.356a2.723 2.723 0 01-2.723-2.722V5.783a.545.545 0 01.545-.545h10.89a2.723 2.723 0 012.723 2.723v5.445a2.723 2.723 0 01-2.723 2.722zm-10.346-9.8v7.079a1.634 1.634 0 001.634 1.631h8.712a1.634 1.634 0 001.634-1.634V7.961a1.634 1.634 0 00-1.634-1.634z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 48",
    d: "M14.157 6.327a.545.545 0 01-.545-.545V4.285a1.269 1.269 0 00-.425-1.018 1.056 1.056 0 00-.909-.174L3.147 5.167a.545.545 0 00-.425.545.545.545 0 01-1.089 0 1.634 1.634 0 011.269-1.607l9.137-2.075a2.124 2.124 0 011.83.387 2.363 2.363 0 01.833 1.868v1.5a.545.545 0 01-.545.542z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 49",
    d: "M15.246 12.861h-3.812a2.178 2.178 0 010-4.356h3.812a.545.545 0 01.545.545v3.267a.545.545 0 01-.545.544zm-3.812-3.267a1.089 1.089 0 000 2.178h3.267V9.594z"
  })), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rect\\xE1ngulo 4",
    fill: "none"
  }))));
}

export default SvgWalletinline;